import { render, staticRenderFns } from "./PenCanvas.vue?vue&type=template&id=2477b9fc&scoped=true&lang=pug&"
import script from "./PenCanvas.vue?vue&type=script&lang=ts&"
export * from "./PenCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./PenCanvas.vue?vue&type=style&index=0&id=2477b9fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477b9fc",
  null
  
)

export default component.exports